import React from 'react';
import PT from 'prop-types';

import Input from 'Components/Input';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';

const DropdownIndicator = (props) => {
  return (
    <div className="select-field__indicator">
      <TriangleIcon className="select-field__icon" direction={props.selectProps.menuIsOpen ? 'up' : 'down'} />
    </div>
  );
};

const Select = ({ options, multiple, fieldProps: { onChange, value, ...fieldProps }, fetchOptions, ...props }) => {
  return (
    <div className="select-field">
      <Input
        variant="select"
        options={options}
        callback={onChange}
        fieldProps={{
          value: value || null,
          components: { DropdownIndicator },
          isMulti: multiple,
          onOpen: fetchOptions,
          ...fieldProps,
        }}
        {...props}
      />
    </div>
  );
};

Select.propTypes = {
  options: PT.arrayOf(PT.object),
  fieldProps: PT.object,
};

export default Select;
